var React = require('react');

function ReadmoreGrey (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.0768 10.9956V15.6512L8.06006 16.8133L6.04333 17.9755L4.02661 19.1377L2.01672 20.2999V20.3067L0 21.4689V16.8133L2.01672 15.6512L4.02661 14.489L6.04333 13.3268L8.06006 12.1646V12.1578L10.0768 10.9956Z","fill":"#C6C6C6","key":0}),React.createElement("path",{"d":"M10.0768 6.34886V10.9976L8.06006 9.8354L6.04333 8.67322L4.02661 7.51104L2.01672 6.34886L0 5.18668V0.531128L2.01672 1.69331L4.02661 2.85549L6.04333 4.01767L8.06006 5.18668L10.0768 6.34886Z","fill":"#C6C6C6","key":1})]);
}

ReadmoreGrey.defaultProps = {"width":"11","height":"22","viewBox":"0 0 11 22","fill":"none"};

module.exports = ReadmoreGrey;

ReadmoreGrey.default = ReadmoreGrey;
